import {
  FDAvatar, FDBodyText,
  FDSecondaryActionIconButton, FDStack, FDTitleText,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import TaxStrategySummaryNoteDialog
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategySummaryNoteDialog';
import moment from 'moment';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import PropTypes from 'prop-types';


const TaxStrategyInternalNoteLayout = ({ onSubmit }) => {
  const { resource } = useMetaLayoutContext();
  const [open, setOpen] = React.useState(false);
  return (
    <FDStack direction={'column'} spacing={1}>
      <FDStack direction={'row'} spacing={2} justifyContent={'flex-start'} alignItems={'center'}>
        <FDStack direction={'column'} spacing={1}>
          <FDTitleText value={resource.attr('title')} />
          <FDStack direction={'row'} spacing={2} justifyContent={'flex-start'} alignItems={'center'}>
            <FDAvatar alt={resource.relationship(fr.relationships.profileImage.name)?.meta('altText') || ''} src={resource.relationship(fr.relationships.profileImage.name)?.link('related').url() || ''} size={'sm'} />
            <FDStack direction={'column'}>
              <FDBodyText size={'md'} color={'textSecondary'} value={resource.attr('lastUpdatedBy')} />
              <FDBodyText size={'sm'} value={resource.attr('lastUpdatedAt') ? moment(resource.attr('lastUpdatedAt')).format('MM/DD/YY - h:mm A') : ''} />
            </FDStack>
          </FDStack>
        </FDStack>
        <FDSecondaryActionIconButton
          icon={'edit'}
          onClick={(evt) => {
            evt.stopPropagation();
            evt.preventDefault();
            setOpen(true);
          }}
        />
      </FDStack>
      <Richtext
        Component={FDBodyText}
        size={'md'}
        value={resource.attr('content')}
        richtext={resource.metaField('content').attr('hint') === 'richtext'}
      />
      <TaxStrategySummaryNoteDialog
        open={open}
        setOpen={setOpen}
        onClose={onSubmit}
      />
    </FDStack>
  );
};

TaxStrategyInternalNoteLayout.defaultProps = {
};

TaxStrategyInternalNoteLayout.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default TaxStrategyInternalNoteLayout;
